import { AddedPopup } from "./AddedPopup";

export default AddedPopup;
